import { z } from 'zod'

export const ResponsibleTicketIndicators = z.object({
  totalTickets: z.number(),
  totalCompleted: z.number(),
  completionPercentage: z.number(),
  averageResponseTime: z.string(),
  averageCompletionTime: z.string(),
  inAnalysisCount: z.number(),
  csat: z.number().nullish(),
  star: z.number().nullish(),
  waitingForAnalysisCount: z.number(),
  pendingCount: z.number(),
  completedCount: z.number(),
  totalReviews: z.number().nullish(),
  averageReviews: z.number().nullish()
})

export type ResponsibleTicketIndicators = z.infer<
  typeof ResponsibleTicketIndicators
>
export const AreaTicketIndicatorsResponsible = z.object({
  responsibleId: z.string(),
  areaId: z.string().optional(),
  month: z.number(),
  year: z.number()
})
export const AreaTicketIndicatorsDTO = z.object({
  areaId: z.string().optional(),
  month: z.number(),
  year: z.number()
})

export type AreaTicketIndicatorsDTO = z.infer<typeof AreaTicketIndicatorsDTO>
export type AreaTicketIndicatorsResponsible = z.infer<
  typeof AreaTicketIndicatorsResponsible
>
